import { render, staticRenderFns } from "./CardIntros.vue?vue&type=template&id=0536a20e&scoped=true&"
import script from "./CardIntros.vue?vue&type=script&lang=js&"
export * from "./CardIntros.vue?vue&type=script&lang=js&"
import style0 from "./CardIntros.vue?vue&type=style&index=0&id=0536a20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0536a20e",
  null
  
)

export default component.exports